import { Button, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceHistoryToolPanel extends Layout {
    buttonBalanceDue: Button;
    buttonManuallyTransmit: Button;
    panel1: Panel;
    panel3: Panel;
    panelButtons: Panel;
}
